import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';
import { centerInfo } from '../utils/mockData';

export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">
              Centre Linguistique Russe
            </h3>
            <p className="text-sm mb-4">
              Votre partenaire de confiance pour l'apprentissage de la langue russe au Cameroun depuis 2012.
            </p>
            <div className="flex gap-3">
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-[#0039A6] flex items-center justify-center hover:bg-[#0052d4] transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={18} />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-[#D52B1E] flex items-center justify-center hover:bg-[#b82418] transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-[#007A5E] flex items-center justify-center hover:bg-[#00654d] transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Liens Rapides</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-white transition-colors">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm hover:text-white transition-colors">
                  À Propos
                </Link>
              </li>
              <li>
                <Link to="/courses" className="text-sm hover:text-white transition-colors">
                  Nos Cours
                </Link>
              </li>
              <li>
                <Link to="/partners" className="text-sm hover:text-white transition-colors">
                  Partenaires BRICS
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-sm hover:text-white transition-colors">
                  Galerie
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Courses */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Nos Cours</h3>
            <ul className="space-y-2 text-sm">
              <li className="hover:text-white transition-colors cursor-pointer">
                Russe Débutant A1
              </li>
              <li className="hover:text-white transition-colors cursor-pointer">
                Russe Intermédiaire B1
              </li>
              <li className="hover:text-white transition-colors cursor-pointer">
                Russe Avancé B2-C1
              </li>
              <li className="hover:text-white transition-colors cursor-pointer">
                Anglais Débutant A1
              </li>
              <li className="hover:text-white transition-colors cursor-pointer">
                Anglais Intermédiaire B1
              </li>
              <li className="hover:text-white transition-colors cursor-pointer">
                Préparation TORFL/TOEFL
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-[#FCD116] mt-1 flex-shrink-0" />
                <span className="text-sm">{centerInfo.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-[#FCD116] flex-shrink-0" />
                <a
                  href={`tel:${centerInfo.phone}`}
                  className="text-sm hover:text-white transition-colors"
                >
                  {centerInfo.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={18} className="text-[#FCD116] flex-shrink-0" />
                <a
                  href={`mailto:${centerInfo.email}`}
                  className="text-sm hover:text-white transition-colors break-all"
                >
                  {centerInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-center md:text-left">
              © 2024 Centre Linguistique Russe du Cameroun. Tous droits réservés.
            </p>
            <div className="flex gap-6 text-sm">
              <a href="#" className="hover:text-white transition-colors">
                Politique de confidentialité
              </a>
              <a href="#" className="hover:text-white transition-colors">
                Conditions d'utilisation
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
